import { Component, effect, ElementRef, input, viewChild, ViewEncapsulation } from '@angular/core';
import { SafeHtmlPipe } from "src/app/pipes/safeHtml/safe-html.pipe";

@Component({
  selector: 'ck-preview',
  imports: [
    SafeHtmlPipe
  ],
  templateUrl: './preview.component.html',
  styleUrl: './preview.component.scss',
  // encapsulation: ViewEncapsulation.None
})
export class PreviewComponent {
  content = input.required<string>();
  preview = viewChild<ElementRef>('preview_container');
  checkboxValues: boolean[] = [];
  allChecked: boolean = false;

  constructor() {
    effect(() => {
      const _ = this.content(); // trigger effect
      setTimeout(() => this.enableCheckboxes());
    });
  }

  private enableCheckboxes() {
    const container = this.preview()?.nativeElement;
    if (!container) return;

    const checkboxes = container.querySelectorAll('input[type="checkbox"][disabled]');
    checkboxes.forEach((checkbox: HTMLInputElement) => checkbox.removeAttribute('disabled'));
  }

  public emitCheckboxValues() {
    const container = this.preview()?.nativeElement;
    if (!container) return;

    const labels = container.querySelectorAll('.todo-list__label');
    const result: boolean[] = [];

    labels.forEach((label: HTMLElement) => {
      const checkbox = label.querySelector<HTMLInputElement>('input[type="checkbox"]');
      result.push(checkbox?.checked ?? false);
    });

    this.checkboxValues = result;
    this.allChecked = result.every(Boolean);
  }
}
